import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { ErrorCode, ERROR_MESSAGES } from 'app/shared/models/error.models';

@Component({
  imports: [IconComponent],
  selector: 'app-error-state',
  styleUrl: './error-state.component.scss',
  templateUrl: './error-state.component.html',
})
export class ErrorStateComponent {
  readonly errorCode: InputSignal<ErrorCode | string | null> = input<ErrorCode | string | null>(
    null
  );
  readonly errorMsg: Signal<string> = computed<string>(() => {
    const errorCode: ErrorCode = this.normalizeErrorCode(this.errorCode());

    return ERROR_MESSAGES[errorCode];
  });

  private normalizeErrorCode(errorCode: ErrorCode | string | null): ErrorCode {
    if (errorCode === null || errorCode === '') return ErrorCode.UNKNOWN_ERROR;

    const numericErrorCode: number = Number(errorCode);

    if (Object.values(ErrorCode).includes(numericErrorCode)) return numericErrorCode as ErrorCode;

    return ErrorCode.UNKNOWN_ERROR;
  }
}
